export default __webpack_public_path__ + "static/media/gmail.c03ff4b0.svg";